import type { ReactNode } from 'react';

interface FundoEventoProps {
  imagemUrl?: string | null;
  children: ReactNode;
}

// Fundo desfocado com a capa do evento (ou gradiente da marca), fixo e cobrindo
// a tela inteira. Mesma linguagem visual da rifa e da loja — nada de cinza.
export default function FundoEvento({ imagemUrl, children }: FundoEventoProps) {
  return (
    <div className="relative min-h-screen overflow-x-clip">
      {imagemUrl ? (
        <>
          <img
            src={imagemUrl}
            alt=""
            aria-hidden
            className="fixed inset-0 z-0 h-full w-full object-cover object-center"
            style={{ filter: 'blur(24px)', transform: 'scale(1.1)' }}
            loading="lazy"
            decoding="async"
          />
          <div className="fixed inset-0 z-0 bg-primary-900/60" />
        </>
      ) : (
        <div className="fixed inset-0 z-0 bg-gradient-to-br from-primary-600 via-primary-500 to-primary-400" />
      )}
      <div className="relative z-10 min-h-screen">{children}</div>
    </div>
  );
}